import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=1326ff48&scoped=true&"
import script from "./AppDownload.vue?vue&type=script&lang=js&"
export * from "./AppDownload.vue?vue&type=script&lang=js&"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=1326ff48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326ff48",
  null
  
)

export default component.exports